import React from "react";
import { Stack, Typography, styled, Avatar } from "@mui/material";
import BadgeVisual from "../visuals/BadgeVisual";

const Card = styled(Stack)(({ theme }: any) => ({
  border: `1px solid ${theme.palette.common.borderGrey}`,
  "& .p-2": {
    padding: theme.spacing(2)
  }
}));

export interface SponserCardInterface {
  image: string;
  company: string;
  city: string;
  sponsership?: "silver" | "golden" | "platinum";
  bookmarked?: boolean;
  setBookmarked: () => void;
}
const sponsershipList: any = {
  golden: { label: "Golden Sponser", color: "golden" },
  platinum: { label: "Platinum Sponser", color: "platinum" },
  silver: { label: "Silver Sponser", color: "silver" }
};
const SponserCard = ({
  image,
  company,
  city,
  sponsership,
  bookmarked = false,
  setBookmarked
}: SponserCardInterface) => {
  return (
    <Card spacing={1} alignItems="center">
      <Stack
        width="100%"
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
      >
        {bookmarked
          ? <i className="fas fa-bookmark fa-lg p-2" onClick={setBookmarked} />
          : <i className="far fa-bookmark fa-lg p-2" onClick={setBookmarked} />}
        {sponsership && sponsershipList[sponsership]
          ? <BadgeVisual
              label={sponsershipList[sponsership].label}
              color={sponsershipList[sponsership].color}
              borderPlacement="bottom-left"
              variant="h6"
            />
          : null}
      </Stack>
      <Stack spacing={1} textAlign="center" pb={2}>
        <Avatar
          alt="Remy Sharp"
          src={image}
          sx={{ width: "128px", height: "128px" }}
        />

        <Typography color="primary" fontSize={16} fontWeight={700}>
          {company}
        </Typography>
        <Typography className="font-grey" variant="h5">
          {city}
        </Typography>
      </Stack>
    </Card>
  );
};
export default SponserCard;
